<div class="picklist-preview-table__wrapper">
  <table class="lum-table lum-table--classic striped">
    <tr class="table__head-row">
      <th>Order Date</th>
      <th>Order ID</th>
      <th>Order Number</th>
      <th class="w-auto">Picking Items</th>
    </tr>
    <ng-container>
      <tbody>
        <tr
          *ngFor="let row of items; trackBy: trackById"
          [ngClass]="{
            'table__cell-warning': !row.fulfillmentStatus,
          }"
        >
          <td>
            {{ row.orderDate | date: 'mediumDate' }}
          </td>
          <td>
            {{ row.id }}
          </td>
          <td>
            {{ row.orderNumber }}
          </td>
          <td>
            <table
              class="lum-table lum-table--classic striped"
              *ngIf="row.pickingItems.length > 0"
            >
              <tr class="table__head-row">
                <th>SKU</th>
                <th>Product Name</th>
                <th class="text-center">Ordered Quantity</th>
                <th class="text-center">Available Quantity</th>
                <th>Location</th>
                <th>Lot</th>
              </tr>
              <ng-container>
                <tbody>
                  <tr
                    *ngFor="let pickingItem of row.pickingItems"
                    [ngClass]="{
                      'table__text-danger': pickingItem.availableQuantity <= 0,
                    }"
                  >
                    <td>
                      {{ pickingItem.rfq?.internal_sku }}
                    </td>
                    <td>
                      {{ pickingItem.rfq?.product_name }}
                    </td>
                    <td class="text-center">
                      {{ pickingItem.orderedQuantity | decimalPlaces }}
                    </td>
                    <td class="text-center">
                      {{ pickingItem.availableQuantity | decimalPlaces }}
                    </td>
                    <td>
                      {{ pickingItem.location?.location_name }}
                    </td>
                    <td>
                      {{ pickingItem.lot?.lot_number }}
                    </td>
                  </tr>
                </tbody>
              </ng-container>
            </table>
          </td>
        </tr>
      </tbody>
    </ng-container>
  </table>
</div>
